import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import i18n from '../../../../../config/i18n';
import './styles/TimeMessageItem.css';

const formatTime = (time) => {
  const targetTime = moment(time);
  const currentTime = moment();
  if (targetTime.isSame(currentTime, 'day')) {
    return targetTime.format('hh:mm a');
  }
  if (targetTime.isSame(currentTime.subtract(1, 'days'), 'day')) {
    return `${i18n.t('yesterday')} ${targetTime.format('hh:mm a')}`;
  }
  if (targetTime.isSame(currentTime, 'week')) {
    return targetTime.format('dddd hh:mm a');
  }
  if (targetTime.isSame(currentTime, 'year')) {
    return targetTime.format('MMM Do hh:mm a');
  }
  return targetTime.format('YYYY/MM/DD hh:mm a');
};


const TimeMessageItem = ({
  style,
  time,
}) => (
  <div
    className="time-message-item"
    style={style}
  >
    {formatTime(time)}
  </div>
);

TimeMessageItem.propTypes = {
  style: PropTypes.object,
  time: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
};

TimeMessageItem.defaultProps = {
  style: {},
  time: '',
};

export default TimeMessageItem;



// WEBPACK FOOTER //
// ./src/modules/messaging/components/ChannelDetail/Message/TimeMessageItem.js